import styled from 'styled-components';
import { mediumScreens } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
`;

export const InnerContainer = styled.div`
  padding: 60px 60px 70px;
  text-align: center;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.p`
  padding: 0px 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubTitle = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin: 0px 0px 50px;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled(SubTitle)`
  margin: 0px 0px 20px;
`;

export const Instructions = styled.div`
  width: 90%;
  border-radius: 5px;
  background-color: #f4f7f9;
  padding: 20px;
  margin: 30px auto;
  font-size: 12px;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 11px;
  }
`;

export const InstructionsSection = styled.div`
  margin: 50px auto;
  width: 70%;
`;

export const RadioButtonContainer = styled.div`
  padding-top: 10px;
  margin: 0px auto;
`;

export const RadioButton = styled.input`
  margin: 0.4rem;
  display: inline-block;
  cursor: pointer;
`;

export const RadioButtonLabel = styled.label`
  margin-left: 7px;
  margin-right: 20px;
  font-weight: normal;
  color: gray;
  font-size: 12px;
`;
